export default "__VITE_ASSET__755f4222__"